import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconDocs: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4583 10C11.4583 10.345 11.1783 10.625 10.8333 10.625H5.83333C5.48833 10.625 5.20833 10.345 5.20833 10C5.20833 9.655 5.48833 9.375 5.83333 9.375H10.8333C11.1783 9.375 11.4583 9.655 11.4583 10ZM5.83333 7.29167H8.33333C8.67833 7.29167 8.95833 7.01167 8.95833 6.66667C8.95833 6.32167 8.67833 6.04167 8.33333 6.04167H5.83333C5.48833 6.04167 5.20833 6.32167 5.20833 6.66667C5.20833 7.01167 5.48833 7.29167 5.83333 7.29167ZM10.8333 12.7083H5.83333C5.48833 12.7083 5.20833 12.9883 5.20833 13.3333C5.20833 13.6783 5.48833 13.9583 5.83333 13.9583H10.8333C11.1783 13.9583 11.4583 13.6783 11.4583 13.3333C11.4583 12.9883 11.1783 12.7083 10.8333 12.7083ZM18.125 9.58333V15.8333C18.125 17.0975 17.0975 18.125 15.8333 18.125H5C2.985 18.125 1.875 17.015 1.875 15V5C1.875 2.985 2.985 1.875 5 1.875H11.6667C13.6817 1.875 14.7917 2.985 14.7917 5V7.70833H16.25C17.2833 7.70833 18.125 8.54917 18.125 9.58333ZM13.7925 16.875C13.6325 16.5625 13.5417 16.2083 13.5417 15.8333V5C13.5417 3.68583 12.9808 3.125 11.6667 3.125H5C3.68583 3.125 3.125 3.68583 3.125 5V15C3.125 16.3142 3.68583 16.875 5 16.875H13.7925ZM16.875 9.58333C16.875 9.23833 16.5942 8.95833 16.25 8.95833H14.7917V15.8333C14.7917 16.4075 15.2592 16.875 15.8333 16.875C16.4075 16.875 16.875 16.4075 16.875 15.8333V9.58333Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconDocs;
